var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCotiza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00095b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001",
    transform: "translate(21492.756 23010.271)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    className: "cls-1",
    d: "M246.658,66.76a10.008,10.008,0,1,1,7.069-2.931A10,10,0,0,1,246.658,66.76Zm0-18.554a8.566,8.566,0,1,0,6.047,2.508,8.557,8.557,0,0,0-6.047-2.508Z",
    transform: "translate(-21729.414 -23057.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    className: "cls-1",
    d: "M326.757,99.983a9.69,9.69,0,0,1,2.083.3.721.721,0,0,0,.382-1.392,11.888,11.888,0,0,0-1.744-.31V97.6a.721.721,0,1,0-1.442,0v.988c-1.935.263-2.168,1.582-2.168,2.185,0,1.5,1.544,2.121,2.469,2.512l.178.072.272.11c.933.369,1.341.6,1.341,1.273s-.45,1-1.328,1.035h-.153a8.584,8.584,0,0,1-2.41-.581.721.721,0,1,0-.518,1.345,11.666,11.666,0,0,0,2.317.619v.972a.721.721,0,0,0,1.442,0v-1.005a2.348,2.348,0,0,0,2.092-2.406c0-1.7-1.409-2.257-2.249-2.592l-.424-.178c-.662-.272-1.574-.645-1.574-1.175-.013-.255-.013-.789,1.434-.789Z",
    transform: "translate(-21809.424 -23103.354)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCotiza);
export default __webpack_public_path__ + "static/media/cotiza.f269ea9cb8064e8f8595b067d31c8611.svg";
export { ForwardRef as ReactComponent };